import React from 'react'
import {
  NarrativeBlock as NarrativeBlockData,
  NarrativeSectionKey,
} from '@marketing-milk/interfaces'
import { SurfacePalette, type } from '../../../tokens'
import { sectionNumberFor } from '../../sections'
import { PresentPage } from '../PresentPage'

interface Props {
  palette: SurfacePalette
  sectionKey: NarrativeSectionKey
  label: string
  packetID: number
  narrative: NarrativeBlockData[]
}

export const PresentNarrative = ({ palette, sectionKey, label, packetID, narrative }: Props) => {
  const text = narrative.find(b => b.sectionKey === sectionKey)?.richText?.trim() ?? ''

  return (
    <PresentPage
      palette={palette}
      number={sectionNumberFor(sectionKey)}
      title={label}
      commentAnchor={{ type: 'section', id: `${packetID}:${sectionKey}`, label }}
    >
      <div
        style={{
          fontFamily: type.family.serif,
          fontSize: 32,
          lineHeight: 1.4,
          whiteSpace: 'pre-wrap',
          color: text ? palette.text : palette.textFaint,
          fontStyle: text ? 'normal' : 'italic',
          maxWidth: 760,
        }}
      >
        {text || 'Nothing captured for this section.'}
      </div>
    </PresentPage>
  )
}
